// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section___hP8F"};